import React from "react";
import { connect } from "react-redux";
import IoTLogoCanvas from "components/Canvas/IoTLogoCanvas";

const IoTLogo = ({ user, atlCode }) => {
  const facilityCode = user && user.isLab && user.CATLCode ? user.CATLCode : atlCode;

  if (facilityCode) {
    return <IoTLogoCanvas labCode={facilityCode} />;
  }

  return null;
};

function mapStateToProps({ user }) {
  return { user };
}

export default connect(mapStateToProps)(IoTLogo);